import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { SubTabs, SubTab } from 'components/layout'
import {
  TasksAjEventsTable,
  TasksActivitiesTable,
  TasksResidentialProject
} from 'components/sections/tasks'
import { meta } from 'helpers/decorators'
import {
  apiActivities,
  apiResidentialProjects,
  apiTasksRp,
  apiTasksActivityApproval,
  apiTasksAj,
  apiAjEvents, apiCodeLists,
  apiConfiguration
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'


const enhance = compose(
  meta({
    title: 'Tasks - Activity approval',
    intlKey: 'pageTitle.tasks_activity_approvals'
  }),
  apiConfiguration(),
  connect(null, { modal }),
  apiTasksActivityApproval({
    physical: true,
    skills: true,
    service: true
  }),
  apiTasksRp({
    listApproval: true
  }),
  apiActivities({
    updateActivityTasks: true
  }),
  apiResidentialProjects({
    updateApprovalTasks: true
  }),
  apiTasksAj({
    events: true
  }),
  apiAjEvents(),
  apiCodeLists(['activityReviseReasons']),
)

class TasksActivityApproval extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    tasksAjEvents: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    approveActivity: PropTypes.func.isRequired,
    returnActivity: PropTypes.func.isRequired,
    approveResidentialProject: PropTypes.func.isRequired,
    returnApproveResidentialProject: PropTypes.func.isRequired,
    setRpApprovalParams: PropTypes.func.isRequired,
    approveAjEvent: PropTypes.func.isRequired,
    rejectAjEvent: PropTypes.func.isRequired,
    setTasksAjEventsParams: PropTypes.func.isRequired,
    setActivityApprovalSectionParams: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired
  }

  setPhysicalParams = options =>
    this.props.setActivityApprovalSectionParams(options, 'physical')
  setSkillsParams = options =>
    this.props.setActivityApprovalSectionParams(options, 'skills')
  setServiceParams = options =>
    this.props.setActivityApprovalSectionParams(options, 'service')


  render() {
    const {
      tasks: { activityApproval, rp },
      tasksAjEvents,
      approveActivity,
      returnActivity,
      approveResidentialProject,
      returnApproveResidentialProject,
      setRpApprovalParams,
      approveAjEvent,
      rejectAjEvent,
      setTasksAjEventsParams,
      codeLists
    } = this.props

    return (
      <div>
        <SubTabs onChange={this.handleTabsChange}>
          <SubTab
            title="Physical recreation"
            intlKey="award.physical_recreation"
            svg="physical"
            progress={get(activityApproval, 'physical.list.length')}
          >
            <TasksActivitiesTable
              section='physical'
              tasks={activityApproval.physical}
              approveModal={approveActivity}
              returnModal={returnActivity}
              modal={this.props.modal}
              setParams={this.setPhysicalParams}
              codeLists={codeLists}
            />
          </SubTab>
          <SubTab
            title="Skills"
            svg="skills"
            intlKey="award.skills"
            progress={get(activityApproval, 'skills.list.length')}
          >
            <TasksActivitiesTable
              section='skills'
              tasks={activityApproval.skills}
              approveModal={approveActivity}
              returnModal={returnActivity}
              modal={this.props.modal}
              setParams={this.setSkillsParams}
              codeLists={codeLists}
            />
          </SubTab>
          <SubTab
            title="Service"
            svg="service"
            intlKey="award.service"
            progress={get(activityApproval, 'service.list.length')}
          >
            <TasksActivitiesTable
              section='service'
              tasks={activityApproval.service}
              approveModal={approveActivity}
              returnModal={returnActivity}
              modal={this.props.modal}
              setParams={this.setServiceParams}
              codeLists={codeLists}
            />
          </SubTab>
          <SubTab
            title="Adventurous journeys"
            intlKey="award.ajs"
            svg="aj"
            progress={tasksAjEvents.events.list.length}
          >
            <TasksAjEventsTable
              tasks={tasksAjEvents.events}
              approveModal={approveAjEvent}
              rejectModal={rejectAjEvent}
              modal={this.props.modal}
              setParams={setTasksAjEventsParams}
              codeLists={codeLists}
              hideLimit
            />
          </SubTab>
          <SubTab
            title="Residential Project"
            intlKey="award.rp"
            svg="rp"
            progress={get(rp, 'approval.list.length')}
          >
            <TasksResidentialProject
              tasks={rp.approval}
              list={rp.approval.list}
              approveModal={approveResidentialProject}
              returnModal={returnApproveResidentialProject}
              codeLists={codeLists}
              modal={this.props.modal}
              setParams={setRpApprovalParams}
              hideLimit
            />
          </SubTab>
        </SubTabs>
      </div>
    )
  }
}

export default enhance(TasksActivityApproval)
